/**
 * Slug-Erzeugung für Vorschau-URLs im Office.
 *
 * Spiegelt `backend_fastapi/app/core/slugify.py` — ohne Transliteration würde
 * jeder Umlaut zum Trenner ("Musikalische Früherziehung" ->
 * `musikalische-fr-herziehung`). Die Regeln müssen synchron bleiben, sonst
 * zeigt die Vorschau auf eine andere URL als die Website ausliefert.
 */

/** Zeichen mit eigenem Ersatztext — NFD würde aus "ü" sonst "u" machen, nicht "ue". */
const REPLACEMENTS: Record<string, string> = {
  ä: 'ae',
  ö: 'oe',
  ü: 'ue',
  ß: 'ss',
  æ: 'ae',
  ø: 'oe',
  å: 'aa',
};

/** Kombinierende Akzente (U+0300–U+036F), die NFD vom Grundbuchstaben abtrennt. */
const COMBINING_MARKS = /[̀-ͯ]/g;

/** Erzeugt einen URL-Slug aus beliebigem Text. */
export function slugify(value: string, fallback = 'item'): string {
  const replaced = (value || '')
    .trim()
    .toLowerCase()
    .replace(/[äöüßæøå]/g, (char) => REPLACEMENTS[char] ?? char);

  const slug = replaced
    // NFD trennt Akzente vom Grundbuchstaben, die dann verworfen werden (é -> e).
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '');

  return slug || fallback;
}

/** Slugify eines Pfads; "/" bleibt erhalten, damit Seiten verschachtelt sein können. */
export function slugifyPath(value: string, fallback = 'seite'): string {
  const parts = (value || '')
    .trim()
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .map((segment) => slugify(segment, ''))
    .filter(Boolean);
  return parts.join('/') || fallback;
}
